import { Copy, GraduationCap, RotateCcw } from 'lucide-react';

export type LiksChatMessageTrailingActionsProps = {
  showRetry: boolean;
  isAi: boolean;
  retryLabel: string;
  onRetry?: () => void;
  disableRetry: boolean;
  showImprove: boolean;
  improveLabel?: string;
  onImprove?: () => void;
  showCopy: boolean;
  copied: boolean;
  copiedLabel: string;
  copyLabel: string;
  onCopy: () => void;
};

export function LiksChatMessageTrailingActions({
  showRetry,
  isAi,
  retryLabel,
  onRetry,
  disableRetry,
  showImprove,
  improveLabel,
  onImprove,
  showCopy,
  copied,
  copiedLabel,
  copyLabel,
  onCopy,
}: LiksChatMessageTrailingActionsProps) {
  return (
    <>
      {showRetry && isAi && (
        <button
          type="button"
          className="liks-chat-message__action"
          aria-label={retryLabel}
          onClick={onRetry}
          disabled={disableRetry}
        >
          <RotateCcw
            className="liks-chat-message__action-icon"
            strokeWidth={2}
            aria-hidden
          />
          <span>{retryLabel}</span>
        </button>
      )}

      {showImprove && (
        <button
          type="button"
          className="liks-chat-message__action"
          aria-label={improveLabel}
          onClick={onImprove}
        >
          <GraduationCap
            className="liks-chat-message__action-icon"
            strokeWidth={2}
            aria-hidden
          />
          <span>{improveLabel}</span>
        </button>
      )}

      {showCopy && (
        <button
          type="button"
          className="liks-chat-message__action"
          aria-label={copied ? copiedLabel : copyLabel}
          onClick={onCopy}
        >
          <Copy
            className="liks-chat-message__action-icon"
            strokeWidth={2}
            aria-hidden
          />
          <span>{copied ? copiedLabel : copyLabel}</span>
        </button>
      )}
    </>
  );
}
